import profile from './profile';
import header from './header';
import redirect from './redirect';

export default {
  profile,
  header,
  redirect,
};
